import map from "lodash/map";

// @ts-expect-error legacy
import Formatter from "@/legacy/Formatter";
// @ts-expect-error TS7016
import ReactUtils from "@/legacy/ReactUtils";

export interface RequestChain {
  request: {
    startTime: number;
    endTime: number;
    transferSize: number;
    url: string;
  };
  children: unknown[];
}

interface RequestChainProps {
  key: string;
  chain: RequestChain;
  t0?: number;
}
export const RequestChain = ({key, chain, t0}: RequestChainProps) => {
  const r = chain.request;
  if (t0 === undefined) {
    t0 = r.startTime;
  }
  return (
    <li key={ReactUtils.Key.get(key + chain)}>
      <div>
        [{key}] {r.url} Start: {Formatter.seconds(r.startTime - t0)}, End: {Formatter.seconds(r.endTime - t0)}, Transfer
        Size: {Formatter.humanBytes(r.transferSize)}
      </div>
      <ul key={ReactUtils.Key.get(key + chain)}>
        {map(chain.children, (c, k) => (
          <RequestChain key={k.toString()} chain={c as RequestChain} t0={t0} />
        ))}
      </ul>
    </li>
  );
};
